import { useTranslation } from 'react-i18next';

export function useFriendlyName() {
  const { t } = useTranslation('automation');

  return function getFriendlyName(value) {
    if (!value) return value;
    const events = t('events', { returnObjects: true, defaultValue: {} });
    const actions = t('actions', { returnObjects: true, defaultValue: {} });
    const legacy = t('legacy', { returnObjects: true, defaultValue: {} });
    return events[value] || actions[value] || legacy[value] || value;
  };
}
